import React from 'react';
import { FieldSelect } from '../../components';

import css from './EditListingServiceInfoForm.module.css';

const CustomMockSelectFieldMaybe = props => {
  const { 
    name,
     id, 
     mockOptions, 
     intl,
     mockOption,
     setMockOption,
     mockPrice,
     } = props;
  const mockLabel = intl.formatMessage({
    id: 'EditListingMockForm.mockLabel',
  });

  return mockOptions ? (
    <FieldSelect
     className={css.mock}
      name={name} 
      id={id}
       label={"After the mock interview session, I will send overall feedback to the student (this is not mandatory)?"}
       mockOption={mockOption}
        setMockOption={setMockOption}
        mockPrice={mockPrice}
       >
      <option key="placeholder" value="" disabled selected hidden>
        {"Select an option..."}
      </option>
      {mockOptions.map(c => (
        <option key={c.key} value={c.key}>
          {c.label}
        </option>
      ))}
    </FieldSelect>
  ) : null;
};

export default CustomMockSelectFieldMaybe;
